export default __webpack_public_path__ + "static/media/metamask-network-ropsten.a5527362.png";